elm = require('../../../elm/elm.js')

$ ->
  if $('#testimonial-widget-container').length > 0
    node = $('#testimonial-widget-container').get(0)
    flags = $('#testimonial-widget-container').data('flags')

    app = elm.TestimonialWidget.embed(node, flags)
